import React from 'react';
import styles from './main.module.scss';
import { createBrowserRouter, Navigate, Outlet, RouterProvider } from 'react-router-dom';
import ErrorRoute from './error-route/error-route';
import Header from '../header/header';
import SalesConfiguration from './sales-configuration/sales-configuration';
import PlayerAttributesList from './player-attributes-list/player-attributes-list';
import SalesSteeringList from './sales-steering-list/sales-steering-list';
import BookingRestrictionsList from './booking-restrictions-list/booking-restrictions-list';
import AccommodationBlocking from './accommodation-blocking/accommodation-blocking';
import AccommodationBlockingFormPage
  from './accommodation-blocking/accommodation-blocking-form-page/accommodation-blocking-form-page';
import AccommodationBlockingOverview
  from './accommodation-blocking/accommodation-blocking-overview/accommodation-blocking-overview';
import AccommodationBlockingDelete
  from './accommodation-blocking/accommodation-blocking-delete/accommodation-blocking-delete';

// Shared layout rendered once for all top-level routes below, so the Header (and its
// TabMenu) stays mounted across tab switches instead of fully unmounting/remounting on
// every navigation (see TD-10680: that remount caused the PrimeReact TabMenu <ul> to
// flash as an unstyled bullet list for a moment on every tab switch).
function Layout() {
  return (
    <div>
      <Header />
      <div className={styles.main}>
        <Outlet />
      </div>
    </div>
  );
}

function Main() {
  const router = createBrowserRouter([
    {
      element: <Layout />,
      errorElement: <ErrorRoute />,
      children: [
        {
          path: '/',
          element: <SalesConfiguration />,
        },
        {
          path: '/player-attributes',
          element: <PlayerAttributesList />,
        },
        {
          path: '/sales-steering',
          element: <SalesSteeringList />,
        },
        {
          path: '/booking-restrictions',
          element: <BookingRestrictionsList />,
        },
        {
          path: '/accommodation-blocking',
          element: <AccommodationBlocking />,
          children: [
            {
              index: true,
              element: <Navigate replace to="overview" />,
            },
            {
              path: 'new',
              element: <AccommodationBlockingFormPage mode="new" />,
            },
            {
              path: 'edit/:id',
              element: <AccommodationBlockingFormPage mode="edit" />,
            },
            {
              path: 'copy/:id',
              element: <AccommodationBlockingFormPage mode="copy" />,
            },
            {
              path: 'overview',
              element: <AccommodationBlockingOverview />,
            },
            {
              path: 'delete/:id',
              element: <AccommodationBlockingDelete />,
            },
          ],
        },
      ],
    },
  ]);
  return (
    <div className={styles.app}>
      <RouterProvider router={router} />
    </div>
  );
}

export default Main;
